import React, { useState } from 'react';
import './RightMenu.css';
import PrivacyPolicy from '../Legal/PrivacyPolicy';
import TermsOfService from '../Legal/TermsOfService';
import FAQ from '../Help/FAQ';

function RightMenu({ 
    isOpen, 
    onClose, 
    fov, 
    setFov, 
    galleries, 
    currentGallery, 
    onGallerySelect, 
    onCreateGallery, 
    isLoading,
    setShowStartDashboard,
    isViewMode 
}) {
    const [showControlGuide, setShowControlGuide] = useState(false);
    const [showPrivacy, setShowPrivacy] = useState(false);
    const [showTerms, setShowTerms] = useState(false);
    const [showHelp, setShowHelp] = useState(false);
    
    if (!isOpen) return null;

    const handleGalleriesClick = () => {
        setShowStartDashboard({ show: true, fromGallery: true });
        // Don't close the menu - let the dashboard handle it
    };

    return (
        <>
            <div className="right-menu-overlay" onClick={onClose} data-ui-element />
            <div className={`right-menu ${isOpen ? 'open' : ''}`} data-ui-element>
                <button className="back-home-button" onClick={handleGalleriesClick}>←</button>
                <button className="close-menu-button" onClick={onClose}>×</button>
                
                {currentGallery && (
                    <div className="current-gallery-section">
                        <h2>Current Gallery</h2>
                        <div className="current-gallery-name">
                            {currentGallery.name}
                        </div>
                    </div>
                )}

                <div className="menu-section">
                    <h2>Navigation</h2>
                    <div className="menu-items">
                        <button className="menu-item" onClick={handleGalleriesClick}>
                            <span className="text">Gallery Dashboard</span>
                        </button>
                        {!isViewMode && (
                            <button className="menu-item" onClick={handleGalleriesClick}>
                                <span className="text">My Galleries</span>
                            </button>
                        )}
                    </div>
                </div>

                <div className="menu-section">
                    <h2>Settings</h2>
                    <div className="menu-items">
                        <div className="setting-item">
                            <label>Field of View</label>
                            <div className="fov-control">
                                <input
                                    type="range"
                                    min="30"
                                    max="120"
                                    value={fov}
                                    onChange={(e) => setFov(Number(e.target.value))}
                                    style={{
                                        width: '100%',
                                        accentColor: '#ffffff'
                                    }}
                                />
                                <span className="setting-value">{fov}°</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="menu-section">
                    <h2>Help</h2>
                    <div className="menu-items">
                        <button className="menu-item" onClick={() => setShowHelp(true)}>
                            <span className="text">FAQ & Support</span>
                        </button>
                        <button className="menu-item" onClick={() => setShowControlGuide(true)}>
                            <span className="text">Controls Guide</span>
                        </button>
                    </div>
                </div>

                <div className="menu-section legal-section">
                    <div className="menu-items">
                        <button className="menu-item legal-link" onClick={() => setShowPrivacy(true)}>
                            <span className="text">Privacy Policy</span>
                        </button>
                        <button className="menu-item legal-link" onClick={() => setShowTerms(true)}>
                            <span className="text">Terms of Service</span>
                        </button>
                    </div>
                </div>
            </div>

            {showControlGuide && (
                <div className="control-guide-modal">
                    <div className="modal-content">
                        <button className="modal-close-button" onClick={() => setShowControlGuide(false)}>×</button>
                        <h2>Controls Guide</h2>
                        
                        <div className="control-sections">
                            <div className="control-section">
                                <h3>Movement</h3>
                                <div className="control-item">
                                    <div className="key">W A S D</div>
                                    <div className="description">Move forward/left/back/right</div>
                                </div>
                                <div className="control-item">
                                    <div className="key">Shift</div>
                                    <div className="description">Hold to sprint (2.5x speed)</div>
                                </div>
                                <div className="control-item">
                                    <div className="key">Mouse</div>
                                    <div className="description">Look around (when locked)</div>
                                </div>
                            </div>

                            <div className="control-section">
                                <h3>Camera & View</h3>
                                <div className="control-item">
                                    <div className="key">C</div>
                                    <div className="description">Toggle 1st/3rd person camera</div>
                                </div>
                                <div className="control-item">
                                    <div className="key">Escape</div>
                                    <div className="description">Release mouse lock</div>
                                </div>
                                <div className="control-item">
                                    <div className="key">Click Canvas</div>
                                    <div className="description">Engage mouse lock in view mode</div>
                                </div>
                            </div>

                            <div className="control-section">
                                <h3>Gallery Modes</h3>
                                <div className="control-item">
                                    <div className="key">V</div>
                                    <div className="description">Toggle edit/view mode</div>
                                </div>
                                {!isViewMode && (
                                    <>
                                        <div className="control-item">
                                            <div className="key">Click Spot</div>
                                            <div className="description">Select display spot or asset</div>
                                        </div>
                                        <div className="control-item">
                                            <div className="key">Escape</div>
                                            <div className="description">Deselect current object</div>
                                        </div>
                                    </>
                                )}
                            </div>

                            <div className="control-section">
                                <h3>UI Controls</h3>
                                <div className="control-item">
                                    <div className="key">FOV Slider</div>
                                    <div className="description">Adjust field of view (30°-120°)</div>
                                </div>
                                <div className="control-item">
                                    <div className="key">Menu Button</div>
                                    <div className="description">Access settings and gallery options</div>
                                </div>
                            </div>

                            <div className="control-section">
                                <h3>Mobile Controls</h3>
                                <div className="control-item">
                                    <div className="key">Virtual Joystick</div>
                                    <div className="description">Move around (auto-appears)</div>
                                </div>
                                <div className="control-item">
                                    <div className="key">Touch & Drag</div>
                                    <div className="description">Look around and rotate camera</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showPrivacy && (
                <PrivacyPolicy onClose={() => setShowPrivacy(false)} />
            )}
            
            {showTerms && (
                <TermsOfService onClose={() => setShowTerms(false)} />
            )}
            
            {showHelp && (
                <FAQ onClose={() => setShowHelp(false)} />
            )}
        </>
    );
}

export default React.memo(RightMenu); 